<template>
  <bxs-bottom-sheets
    v-model="visible"
    class="interest_key_explain"
    title="利益演示"
    height="77%"
    :prevent-scroll-through="true"
    :overlay="overlay"
  >
    <dl>
      <template v-for="detail in filterInterestDetailData">
        <template v-if="detail.detail">
          <dt>{{ detail.name }}</dt>
          <dd v-html="detail.detail" />
        </template>
      </template>
    </dl>
  </bxs-bottom-sheets>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    filterInterestDetailData: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      visible: false,
      overlay: false,
    }
  },
  watch: {
    value (v) {
      this.visible = v
      if (v) {
        this.overlay = true
      }
    },
    visible (v) {
      if (!v) {
        this.$emit('input', v)
      }
    }
  },
  mounted () {
    if (this.value) {
      this.overlay = true
    }
  }
}
</script>
<style>
@import './interest-key-explain.css';
</style>
